module.exports = __webpack_public_path__ + "svg/shoulders-broader.7a5d27824a3a45c77dbbc2e6071cab9e.svg";